import React from 'react';
import { StyleSheet } from 'react-native';
import { Card, Title, Paragraph, useTheme } from 'react-native-paper';

const MenuCategoryCard = ({ category, onPress }) => {
  const theme = useTheme();
  
  return (
    <Card 
      style={styles.card} 
      onPress={onPress}
      elevation={2}
    >
      {category.imageUrl && (
        <Card.Cover 
          source={{ uri: category.imageUrl }}
          style={styles.cardImage}
        />
      )}
      <Card.Content style={styles.cardContent}>
        <Title style={styles.title}>{category.name}</Title>
        {category.description && (
          <Paragraph style={styles.description} numberOfLines={2}>
            {category.description}
          </Paragraph>
        )}
        {category.itemCount > 0 && (
          <Paragraph style={styles.itemCount}>
            {category.itemCount} ürün
          </Paragraph>
        )}
      </Card.Content>
    </Card>
  );
};

const styles = StyleSheet.create({
  card: {
    marginVertical: 8,
    borderRadius: 8,
    overflow: 'hidden',
  },
  cardImage: {
    height: 120,
  },
  cardContent: {
    paddingVertical: 12,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  description: {
    marginTop: 4,
    opacity: 0.7,
  },
  itemCount: {
    marginTop: 8,
    fontSize: 12,
    opacity: 0.6,
  },
});

export default MenuCategoryCard;
